import React from 'react';
export function TermsAndConditions() {
  return <div className="prose prose-sm max-w-none" data-id="element-1226">
      <p className="text-gray-600 mb-4" data-id="element-1227">
        <strong data-id="element-1228">Última actualización:</strong> Enero
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1229">1. Aceptación de Términos</h3>
      <p className="text-gray-700 mb-4" data-id="element-1230">
        Al comprar y utilizar el Sistema 50 Recetas Express, aceptas estos
        términos y condiciones. Si no estás de acuerdo, por favor no utilices
        nuestro producto.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1231">
        2. Descripción del Producto
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-1232">
        El Sistema 50 Recetas Express es un producto digital que incluye:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1233">
        <li data-id="element-1234">120+ recetas de 15 minutos en formato PDF</li>
        <li data-id="element-1235">12 menús semanales completos</li>
        <li data-id="element-1236">Guía de Batch Cooking Express</li>
        <li data-id="element-1237">Listas de compras imprimibles</li>
        <li data-id="element-1238">Guía de swaps por país</li>
        <li data-id="element-1239">Acceso a comunidad privada</li>
        <li data-id="element-1240">Actualizaciones mensuales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1241">3. Licencia de Uso</h3>
      <p className="text-gray-700 mb-4" data-id="element-1242">
        Al comprar el sistema, obtienes una licencia personal y no transferible
        para:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1243">
        <li data-id="element-1244">Usar el contenido para tu uso personal y familiar</li>
        <li data-id="element-1245">Imprimir las recetas para uso doméstico</li>
        <li data-id="element-1246">Acceder a las actualizaciones incluidas</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-1247">
        <strong data-id="element-1248">NO está permitido:</strong>
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1249">
        <li data-id="element-1250">Compartir, revender o distribuir el contenido</li>
        <li data-id="element-1251">
          Publicar las recetas en sitios web o redes sociales sin autorización
        </li>
        <li data-id="element-1252">Usar el contenido con fines comerciales</li>
        <li data-id="element-1253">Modificar y redistribuir el material</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1254">4. Garantía de 30 Días</h3>
      <p className="text-gray-700 mb-4" data-id="element-1255">
        Ofrecemos una garantía de satisfacción de 30 días. Si implementas el
        sistema durante un mes y no estás satisfecho, te devolvemos el 100% de
        tu inversión. Para solicitar un reembolso:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1256">
        <li data-id="element-1257">
          Envía un email a{' '}
          <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1258">
            contactomikioscodigital@gmail.com
          </a>
        </li>
        <li data-id="element-1259">Indica tu número de orden</li>
        <li data-id="element-1260">El reembolso se procesará en 5-7 días hábiles</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1261">
        5. Descargo de Responsabilidad
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-1262">Los resultados pueden variar según:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1263">
        <li data-id="element-1264">La consistencia de implementación del sistema</li>
        <li data-id="element-1265">Habilidades culinarias previas</li>
        <li data-id="element-1266">Disponibilidad de ingredientes en tu región</li>
        <li data-id="element-1267">Equipamiento de cocina disponible</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-1268">
        Las recetas están diseñadas para personas sin restricciones alimentarias
        graves. Si tienes alergias o condiciones médicas específicas, consulta
        con un profesional de la salud antes de implementar cambios en tu dieta.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1269">6. Propiedad Intelectual</h3>
      <p className="text-gray-700 mb-4" data-id="element-1270">
        Todo el contenido del Sistema 50 Recetas Express está protegido por
        derechos de autor. Nos reservamos todos los derechos sobre el material.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1271">7. Modificaciones</h3>
      <p className="text-gray-700 mb-4" data-id="element-1272">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán notificados a través de email y actualizados
        en esta página.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1273">8. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-1274">
        Para consultas sobre estos términos:
        <br data-id="element-1275" />
        <strong data-id="element-1276">Email:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1277">
          contactomikioscodigital@gmail.com
        </a>
        <br data-id="element-1278" />
        <strong data-id="element-1279">Soporte:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1280">
          contactomikioscodigital@gmail.com
        </a>
      </p>
    </div>;
}